import { render } from "./post.vue?vue&type=template&id=3eed534a&scoped=true"
import script from "./post.vue?vue&type=script&lang=js"
export * from "./post.vue?vue&type=script&lang=js"

import "./post.vue?vue&type=style&index=0&id=3eed534a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3eed534a"

export default script